import { useNavigate } from "react-router-dom";

export const useNavigatePage = () => {
  const navigate = useNavigate();

  const onMovementPage = (path: string | number) => {
    if (typeof path === "number") {
      navigate(path);
    } else {
      navigate(path);
    }
  };

  return { onMovementPage };
};
